import axios, { AxiosResponse } from 'axios';

export const google = (
	idToken: string,
	inviteToken: string
): Promise<AxiosResponse> =>
	axios.post(`/auth/social/google`, {
		idToken,
		inviteToken,
	});

export const getAuthLink = (): Promise<AxiosResponse> =>
	axios.get(`/auth/oauth2`);

export const startSync = (): Promise<AxiosResponse> =>
	axios.get(`/auth/first-sync`);
